
type LogLevel = 'info' | 'warn' | 'error' | 'success';

interface LogEntry {
  timestamp: number;
  level: LogLevel;
  message: string;
  data?: any;
}

class DebugLogger {
  private logs: LogEntry[] = [];
  private listeners: Function[] = [];
  private maxLogs = 50;

  info(message: string, data?: any) {
    this.addLog('info', message, data);
  }

  log(message: string, data?: any) {
    this.addLog('info', message, data);
  }

  warn(message: string, data?: any) {
    this.addLog('warn', message, data);
  }

  error(message: string, data?: any) {
    this.addLog('error', message, data);
  }

  success(message: string, data?: any) {
    this.addLog('success', message, data);
  }

  private addLog(level: LogLevel, message: string, data?: any) {
    const entry: LogEntry = {
      timestamp: Date.now(),
      level,
      message,
      data
    };

    this.logs.unshift(entry);
    
    if (this.logs.length > this.maxLogs) {
      this.logs.pop();
    }

    this.notifyListeners();
    
    // Also log to console
    const consoleMethod = level === 'success' ? 'log' : level;
    console[consoleMethod](`[Debug] ${message}`, data || '');
  }

  getLogs() {
    return this.logs;
  }

  subscribe(listener: Function) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  private notifyListeners() {
    this.listeners.forEach(l => l(this.logs));
  }

  clear() {
    this.logs = [];
    this.notifyListeners();
  }
}

const debugLogger = new DebugLogger();
export default debugLogger;

